// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc, ta-code-conventions/has-matching-test */
import * as React from 'react';
import { useMutation } from 'urql';
import Logging from '@ta/common.logging';
import FeedImpressionMutation, {
  type FeedImpressionMutationVariables,
} from './FeedImpressionMutation.gql';

/** Mixer-style feed impression tracking. Not to be confused with common/tracking/impressions, which is mostly used for trips tracking */

/** Tracks a feed impression. Keep the resolved promise value opaque as tracking should be fire-and-forget (no one should be depending on what the promise resolves to) */
export type TrackFeedImpression = FeedImpressionMutationVariables => Promise<mixed>;

type Props = {|
  /** A render prop that provides a function to track a feed impression */
  children: TrackFeedImpression => React.Node,
|};

const FeedImpressionLogger = ({ children }: Props) => {
  const [, mutate] = useMutation(FeedImpressionMutation);
  return children(variables =>
    mutate(variables).catch(error => {
      const formattedString = Object.entries(variables)
        .map(entry => `(${entry[0]}:${JSON.stringify(entry[1]) || ''})`)
        .join(', ');
      const message = `Error occurred while tracking feed impressions with variables ${formattedString}`;
      if (DEBUG) {
        Logging.error(message, error);
      } else {
        Logging.warn(message, error);
      }
    }),
  );
};

export default FeedImpressionLogger;
